/**
 * PKCE S256 — porte fiel de keycloak_pkce_service.dart. code_verifier 64 chars url-safe,
 * state 32 chars, ambos via crypto.getRandomValues (nunca Math.random).
 */
function base64UrlFromBytes(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function randomUrlSafeString(byteLength: number): string {
  return base64UrlFromBytes(crypto.getRandomValues(new Uint8Array(byteLength)));
}

async function sha256Base64Url(value: string): Promise<string> {
  const data = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlFromBytes(new Uint8Array(digest));
}

export interface PkceHandshake {
  codeVerifier: string;
  codeChallenge: string;
  state: string;
}

export async function createPkceHandshake(): Promise<PkceHandshake> {
  // 48 e 24 bytes produzem exatamente 64 e 32 caracteres base64url sem padding.
  const codeVerifier = randomUrlSafeString(48);
  const state = randomUrlSafeString(24);
  const codeChallenge = await sha256Base64Url(codeVerifier);
  return { codeVerifier, codeChallenge, state };
}
